import React from 'react';
import PropTypes from 'prop-types';
import {defaultStyles} from './modal.config';
import AppModal from '../../components/Modal/AppModal';
import RestaurantClosedModal from '../RestaurantClosedModal/RestaurantClosedModal';
import {RESTAURANT_CANNOT_ACCEPT_ORDERS} from '../../constants/errorCodes';
import {
  DISABLED_MEAL,
  IOS_PRIVATE_MODE,
  TABLE_BOOKING_SUCCESS,
  FEEDBACK_FULFILLMENT_ERROR,
  MEAL_PICTURE
} from '../../constants/modalType';
import {IosPrivateModeModal} from '../ModalContent/IosPrivateModeModal';
import {TableBookingModal} from '../ModalContent/TableBookModal';
import DisabledMealModal from '../ModalContent/MealDisabledModal';
import FeedbackErrorModal from '../ModalContent/FeedbackErrorModal';
import PictureModal from '../ModalContent/PictureModal';

export const InfoModal = props => {
  let modalContent;
  switch (props.type) {
    case RESTAURANT_CANNOT_ACCEPT_ORDERS:
      modalContent = <RestaurantClosedModal />;
      break;
    case IOS_PRIVATE_MODE:
      modalContent = <IosPrivateModeModal />;
      break;
    case TABLE_BOOKING_SUCCESS:
      modalContent = <TableBookingModal />;
      break;
    case DISABLED_MEAL:
      modalContent = <DisabledMealModal disabledMealDays={props.data} />;
      break;
    case FEEDBACK_FULFILLMENT_ERROR:
      modalContent = <FeedbackErrorModal />;
      break;
    case MEAL_PICTURE:
      modalContent = <PictureModal data={props.data} />;
      break;
    default:
      break;
  }

  return (
    <AppModal
      customStyles={defaultStyles}
      callback={props.closeModalCallback}
    >
      {modalContent}
    </AppModal>
  );
};

InfoModal.propTypes = {
  type: PropTypes.string.isRequired,
  closeModalCallback: PropTypes.func.isRequired,
  data: PropTypes.any //eslint-disable-line react/forbid-prop-types
};

export default InfoModal;



// WEBPACK FOOTER //
// ./components/Modal/InfoModal.js